export default "__VITE_ASSET__CKudGWwe__"